import { Gift, GiftsState } from 'acscp/store';

export interface BasketItem {
    gift: Gift;
    quantity: number;
}

const totalPriceOfBasketItems = (basketItems: BasketItem[]): number =>
    basketItems.reduce((t, item) => t + item.gift.price * item.quantity, 0);

const getItemsInBasket = (giftsState: GiftsState): BasketItem[] =>
    Object.keys(giftsState.giftBasketQuantities).map(giftId => ({
        gift: giftsState.giftsList[giftId],
        quantity: giftsState.giftBasketQuantities[giftId]
    }));

export const getValidItemsInBasket = (giftsState: GiftsState): BasketItem[] =>
    getItemsInBasket(giftsState).filter(basketItem => !!basketItem.gift);

export const getInvalidItemsInBasket = (giftsState: GiftsState): BasketItem[] =>
    getItemsInBasket(giftsState).filter(basketItem => !basketItem.gift);

export const getTotalNumberOfValidGiftsInBasket = (giftsState: GiftsState): number =>
    getValidItemsInBasket(giftsState)
        .reduce((total, item) => getQuantityOfGiftInBasket(giftsState, item.gift) + total, 0);

export const getTotalCostOfValidItemsInBasket = (giftsState: GiftsState): number =>
    totalPriceOfBasketItems(getValidItemsInBasket(giftsState));

export const getRemainingBalanceAfterSubmittingCurrentBasket = (giftsState: GiftsState): number =>
    (giftsState.balance || 0) - getTotalCostOfValidItemsInBasket(giftsState);

export const getQuantityOfGiftInBasket = (giftsState: GiftsState, gift: Gift): number =>
    giftsState.giftBasketQuantities[gift.id] || 0;
